import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LcsChipInputDirective } from './chip-input.directive';

@NgModule({
   declarations: [LcsChipInputDirective],
   exports: [LcsChipInputDirective],
   imports: [CommonModule],
})
export class LcsChipInputModule {}
